import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Modal,
} from 'react-bootstrap';

class ConfirmationModal extends PureComponent {
  render() {
    const {
      show, message, title, onConfirm, onClose,
    } = this.props;
    return (
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="dark" onClick={onConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ConfirmationModal.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string,
  title: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

ConfirmationModal.defaultProps = {
  show: false,
  message: 'Are you sure you want to execute this action?',
  title: 'Confirmation',
};

export default ConfirmationModal;
